export const FETCH_INVOICES_DATA_START = "FETCH_INVOICES_DATA_START";
export const FETCH_INVOICES_DATA_SUCCESS = "FETCH_INVOICES_DATA_SUCCESS";
export const FETCH_INVOICES_DATA_FAIL = "FETCH_INVOICES_DATA_FAIL";

export const FETCH_INVOICES_DROPDOWN_START = "FETCH_INVOICES_DROPDOWN_START";
export const FETCH_INVOICES_DROPDOWN_SUCCESS = "FETCH_INVOICES_DROPDOWN_SUCCESS";
export const FETCH_INVOICES_DROPDOWN_FAIL = "FETCH_INVOICES_DROPDOWN_FAIL";

export const SET_INVOICE_CURRENT_PAGE = "SET_INVOICE_CURRENT_PAGE";

export const SET_INVOICE_PAGE_SIZE = "SET_INVOICE_PAGE_SIZE";

export const SET_INVOICES_SEARCH_INPUT = "SET_INVOICES_SEARCH_INPUT";

export const SET_INVOICES_DROPDOWN_ID = "SET_INVOICES_DROPDOWN_ID";

export const RESET_INVOICE = "RESET_INVOICE";

export const SET_INVOICE_STATUS = "SET_INVOICE_STATUS";
export const SET_INVOICE_DATE = "SET_INVOICE_DATE";
export const SET_USER_EMAIL = "SET_USER_EMAIL";
